function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

(function () {
  var app = angular.module('lif.controllers').controller('calendarEventsListingBlockController', calendarEventsListingBlockController);
  calendarEventsListingBlockController.$inject = ['$scope', '$rootScope', '$http', '$httpParamSerializer', '$timeout', 'calendarEventListingBlockFactory'];

  function calendarEventsListingBlockController($scope, $rootScope, $http, $httpParamSerializer, $timeout, calendarEventListingBlockFactory) {
    var vm = this;
    vm.showAddEventInformation = false;
    vm.maximumAmountOfFilesToShow = 100;
    vm.firstEvent = [];
    vm.allExceptFirstEvents = [];
    vm.hasEvents = false;
    vm.selectedEvent = {};
    vm.editEvent = {};
    vm.submitButtonText = calendarEventListingBlockFactory.texts.submitButtonAdd;
    vm.collapsedEvents = true;

    $scope.$onInit = function () {
      window.resizeLeftNavbar();
    };

    vm.addEvent = function () {
      vm.showAddEventInformation = !vm.showAddEventInformation;
      vm.submitButtonText = calendarEventListingBlockFactory.texts.submitButtonAdd;
      vm.editEvent = undefined;
    };

    $scope.init = function (settings) {
      vm.settings = settings;
      var listUrl = calendarEventListingBlockFactory.apiEndpoints.list + '?contentReferenceId=' + vm.settings.currentBlock;
      $http.get(listUrl).then(function (response) {
        vm.Events = response.data.Events || [];
        vm.Editable = response.data.Editable;
        vm.firstEvent = vm.Events[0] ? [vm.Events[0]] : [];
        vm.allExceptFirstEvents = vm.Events.slice(1);
        vm.hasEvents = vm.firstEvent.length > 0;
      }, function (response) {});
    };

    vm.expandCollapseEvents = function () {
      vm.collapsedEvents = !vm.collapsedEvents;
    };

    vm.onRemoveEventButtonClick = function (calendarEvent) {
      var formData = new FormData();
      formData.append("currentGroupCalendarEventId", vm.fileToRemove.PageId);
      var xhr = new XMLHttpRequest();
      waitingDialog.show(calendarEventListingBlockFactory.texts.saveInProgress);
      xhr.open("POST", calendarEventListingBlockFactory.apiEndpoints.delete, true);

      xhr.onreadystatechange = function (oEvent) {
        if (xhr.readyState === 4) {
          if (xhr.status === 0) {
            return;
          }

          if (xhr.status === 200) {
            waitingDialog.hide();
            vm.fileToRemove = null;

            if (calendarEvent === vm.firstEvent[0]) {
              vm.firstEvent.pop();

              if (vm.allExceptFirstEvents.length > 0) {
                vm.firstEvent[0] = vm.allExceptFirstEvents[0];
                vm.allExceptFirstEvents.splice(vm.allExceptFirstEvents.indexOf(vm.allExceptFirstEvents[0]), 1);
              } else {
                vm.hasEvents = false;
              }
            } else {
              vm.allExceptFirstEvents.splice(vm.allExceptFirstEvents.indexOf(calendarEvent), 1);
            }

            vm.editEvent = null;
            $scope.$apply();
          } else {
            waitingDialog.hide();
            alert(calendarEventListingBlockFactory.texts.serverErrorAdd);
          }
        }
      };

      xhr.send(formData);
      vm.showRemoveModal = false;
    };

    vm.onDeleteEventButtonClick = function (calendarEvent) {
      vm.fileToRemove = calendarEvent;
      vm.showRemoveModal = true; // Use AngularJS to control visibility
    };

    vm.onSaveEventButtonClick = function (calendarEvent) {
      if ($('#' + vm.settings.uniqueId + '-addEventForm')[0].checkValidity()) {
        var formData = new FormData();

        if (calendarEvent != null) {
          formData.append("currentCalendarEvent", calendarEvent.PageId);
        }

        for (var _i = 0, _Object$entries = Object.entries(vm.editEvent); _i < _Object$entries.length; _i++) {
          var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
              key = _Object$entries$_i[0],
              value = _Object$entries$_i[1];

          formData.append(key, value);
        }

        var xhr = new XMLHttpRequest();
        waitingDialog.show(calendarEventListingBlockFactory.texts.saveInProgress);

        if (calendarEvent.PageId != null) {
          xhr.open("POST", calendarEventListingBlockFactory.apiEndpoints.edit + '?currentCalendarPageId=' + vm.settings.currentCalendarPageId, true);
        } else {
          xhr.open("POST", calendarEventListingBlockFactory.apiEndpoints.add + '?currentCalendarPageId=' + vm.settings.currentCalendarPageId, true);
        }

        xhr.onreadystatechange = function (oEvent) {
          if (xhr.readyState === 4) {
            if (xhr.status === 0) {
              return;
            }

            if (xhr.status === 200) {
              var listUrl = calendarEventListingBlockFactory.apiEndpoints.list + '?contentReferenceId=' + vm.settings.currentBlock;
              $http.get(listUrl).then(function (response) {
                vm.Events = response.data.Events;
                vm.Editable = response.data.Editable;
                vm.firstEvent = [vm.Events[0]];
                vm.allExceptFirstEvents = vm.Events.slice(1);
                vm.hasEvents = vm.firstEvent.length > 0;
                vm.editEvent = null;

                if (vm.showAddEventInformation) {
                  vm.showAddEventInformation = !vm.showAddEventInformation;
                }

                waitingDialog.hide(); // Reloading page after save to empty cache for chkedit control. Only solution I could find.                      

                location.reload();
              }, function (response) {
                waitingDialog.hide();

                if (calendarEvent.PageId != null) {
                  alert(calendarEventListingBlockFactory.texts.serverErrorEdit);
                } else {
                  alert(calendarEventListingBlockFactory.texts.serverErrorAdd);
                }
              });
            } else if (xhr.status === 400) {
              waitingDialog.hide();

              if (calendarEvent.PageId != null) {
                alert(calendarEventListingBlockFactory.texts.descriptionRequiredEdit);
              } else {
                alert(calendarEventListingBlockFactory.texts.descriptionRequiredAdd);
              }
            } else {
              waitingDialog.hide();

              if (calendarEvent.PageId != null) {
                alert(calendarEventListingBlockFactory.texts.serverErrorEdit);
              } else {
                alert(calendarEventListingBlockFactory.texts.serverErrorAdd);
              }
            }
          }
        };

        xhr.send(formData);
      }
    };

    vm.onEditEventButtonClick = function (calendarEvent) {
      vm.submitButtonText = calendarEventListingBlockFactory.texts.submitButtonEdit;
      vm.selectedEvent = calendarEvent;
      vm.editEvent = angular.copy(calendarEvent);

      if (!vm.showAddEventInformation) {
        vm.showAddEventInformation = true;
      }
    };

    vm.onInviteEventButtonClick = function (calendarEventId) {
      var url = calendarEventListingBlockFactory.apiEndpoints.invite + calendarEventId;
      waitingDialog.show('Sparar i kalendern...');
      $.ajax({
        url: url,
        type: 'GET',
        success: function success(result) {
          waitingDialog.hide();
        },
        error: function error(_error) {
          waitingDialog.hide();
        }
      });
    };

    jQuery.fn.ForceNumericOnly = function () {
      return this.each(function () {
        $(this).keydown(function (e) {
          var key = e.charCode || e.keyCode || 0;
          return key == 8 || key == 9 || key == 13 || key == 46 || key == 110 || key == 190
          /* . */
          || key == 188
          /* , */
          || key >= 35 && key <= 40 || key >= 48 && key <= 57 || key >= 96 && key <= 105;
        });
      });
    };

    $('#duration').ForceNumericOnly();
  }

  app.directive('datepicker', function () {
    return {
      restrict: 'A',
      require: 'ngModel',
      compile: function compile() {
        return {
          pre: function pre(scope, element, attrs, ngModelCtrl) {
            $(element).datetimepicker({
              format: 'YYYY-MM-DD HH:mm',
              allowInputToggle: true
            }).on('dp.change', function (e) {
              scope.$apply(function () {
                ngModelCtrl.$setViewValue($('input', e.target).val());
              });
            });
          }
        };
      }
    };
  });
  app.directive('ckeditor', function () {
    return {
      require: 'ngModel',
      link: function link(scope, element, attr, ngModel) {
        var editor = $(element[0]).ckeditor({
          toolbar: [{
            name: 'basicstyles',
            items: ['Bold', 'Italic', 'Underline', '-', 'NumberedList', 'BulletedList', '-', 'Link', 'Unlink']
          }],
          contentsCss: window.CKEDITOR_BASEPATH + 'contents.css'
        }).editor;
        editor.on('change', function (evt) {
          scope.$apply(function () {
            ngModel.$setViewValue(evt.editor.getData());
          });
        });
      }
    };
  });
})();